import { render, staticRenderFns } from "./PsActivity.vue?vue&type=template&id=5ff74c7f&scoped=true"
import script from "./PsActivity.vue?vue&type=script&lang=ts"
export * from "./PsActivity.vue?vue&type=script&lang=ts"
import style0 from "./psActivity.css?vue&type=style&index=0&id=5ff74c7f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff74c7f",
  null
  
)

export default component.exports